var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.navbarVisible)?_c('div',[_c('the-nav-bar')],1):_vm._e(),_c('div',{class:[_vm.navbarVisible ? 'mt-5' : '']},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }